import { MantineProvider } from '@mantine/core';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { FEATURE } from '~/common/enums/feature.enum';
import { useHomePageEnabled } from '~/common/hooks/useHomePageEnabled';
import { useTreatments } from '~/domains/common/hooks/useTreatments';
import { Routes } from '~/domains/common/constants/routes';
import Home from '~/domains/home/Home';
import { PusherContextProvider } from '~/domains/pusher/PusherContext';

function HomePage() {
  const router = useRouter();
  const { isSettled: isLightThemeSettled, treatments } = useTreatments([
    FEATURE.ENABLE_HOME_PAGE_LIGHT_THEME,
    FEATURE.CONFIG_PUSHER_ENABLED_ENDPOINTS,
  ]);
  const isLightThemeEnabled = treatments[FEATURE.ENABLE_HOME_PAGE_LIGHT_THEME]?.treatment === 'on';
  const isPusherEnabled = treatments[FEATURE.CONFIG_PUSHER_ENABLED_ENDPOINTS]?.treatment === 'on';

  const { isSettled: isHomePageSettled, isHomePageEnabled } = useHomePageEnabled();

  const isSettled = isLightThemeSettled && isHomePageSettled;

  useEffect(() => {
    if (isSettled && !isHomePageEnabled) {
      router.replace(Routes.contestLobby());
    }
  }, [isHomePageEnabled, isSettled, router]);

  if (!isSettled || !isHomePageEnabled) {
    return null;
  }

  return (
    <MantineProvider inherit theme={{ colorScheme: isLightThemeEnabled ? 'light' : 'dark' }}>
      <PusherContextProvider enabled={isPusherEnabled}>
        <Home />
      </PusherContextProvider>
    </MantineProvider>
  );
}

export default HomePage;

HomePage.isPublic = true;
